/**
 * URLs locais da bolha otimista.
 *
 * Bolhas otimistas usam `URL.createObjectURL` registrado por
 * `clientMessageId`; o blob também é persistido em IndexedDB para a fila
 * offline, então aqui só mora o registro em memória (e o revoke).
 */
const localUrls = new Map<string, string>();
const localBlobs = new Map<string, Blob>();

/** Registra o blob local e devolve a object URL para render imediato. */
export function registerLocalMedia(clientMessageId: string, blob: Blob): string {
  releaseLocalMedia(clientMessageId);
  localBlobs.set(clientMessageId, blob);
  const url = URL.createObjectURL(blob);
  localUrls.set(clientMessageId, url);
  return url;
}

export function localMediaUrl(clientMessageId: string): string | undefined {
  return localUrls.get(clientMessageId);
}

/** Blob em memória (pós-reload, cai para o IndexedDB via `readMediaBlob`). */
export function takeLocalBlob(clientMessageId: string): Blob | undefined {
  return localBlobs.get(clientMessageId);
}

export function releaseLocalMedia(clientMessageId: string): void {
  const url = localUrls.get(clientMessageId);
  if (url) URL.revokeObjectURL(url);
  localUrls.delete(clientMessageId);
  localBlobs.delete(clientMessageId);
}
